



























































































































































import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
  CANT_SEE_SECTION_MSG,
  CompanyID,
    formatDate,
    formatList,
    formRules,
    getAlertColorByPriority,
    getCurrentTimestamp,
    getIndexFromList,
    getPropertyFromList,
    ID, isNullOrEmpty, matchedIndexIdInArray, OptionalCompany, parameterValueValidation, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment, { invalid } from 'moment';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, ParameterValue } from '../../../features/core/models/';
import { SettingsService } from '../api/SettingsService';
import { NormsServices } from '../../norms/api/NormsServices';
import { ecuIsNotScannerMsg, ecuIsScanner, ecuScanner } from '../../norms/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { JourneysCalcTypes } from '../../journeys/models/Configuration';
import { CompaniesService } from '../api/CompaniesService';
import ActivateJourneys from './ActivateJourneys.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyDetail } from '../models/Companies';



@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SectionTitle,
        MultipleSelect,
        ActivateJourneys,
        DeleteConfirmation,
        Input
    }
})
export default class ConfigureJourneysModules extends Mixins(
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: null}) companyData: CompanyDetail;
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) hasActiveJourney: boolean;
    @Prop({default: -1}) companyId: number;
    modalTitle: string = 'Configuracion de Jornales';
    activeColor: string = 'primary';
    inactiveColor: string = getAlertColorByPriority();
    activeJourneyText: string = 'Activar';
    deactivateJourneyText: string = 'Desactivar';
    visibleModalActivateJourneys: boolean = false;
    loadingJourneys: boolean = false;
    activatingMDP: boolean = false;
    deactivateIcon: string = 'mdi-close-circle';
    activateIcon: string = 'mdi-checkbox-marked-circle';
    summaryDeactivate: string[] = [];
    username: string = '';
    userpassword: string = '';
    hasActiveMdP: boolean = false;
    updatingMDPConfig: boolean = false;
    deactivateEvent: string = '';
    openMdpPanel: null | number = null;

    get canSaveMDPConfig(){
        return !isNullOrEmpty(this.username) && !isNullOrEmpty(this.userpassword);
    }


    
    saveMDPConfig(){
        if(this.companyHasMDPActive){
            this.updateMDPConfig();
        }else{
            this.activateMDP();
        }
        
    }



    @Watch('companyData', { immediate: true, deep: true })
    onCompanyDataChange(value: CompanyDetail) {
        this.hasActiveMdP = value.mdp.is_active;
        this.updateUsername(value.mdp.username);
        this.updateUserpassword(value.mdp.password);
    }

    updateUsername(value){
        this.username = value;
    }

    updateUserpassword(value){
        this.userpassword = value;
    }

    pendingMDP(value){
        this.activatingMDP = value;
    }

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    pendingRequestInsuranceFarming: boolean = false;

    get getColorJourneyButton(){
        return !this.hasActiveJourney ? this.activeColor : this.inactiveColor;
    }

    get getJourneyBtnLabel(){
        return this.hasActiveJourney ? this.deactivateJourneyText : this.activeJourneyText
    }

    get companyHasMDPActive(){
        return this.hasActiveMdP
    }

    activateOrDeactivateMDP(){
        if(this.companyHasMDPActive){
            this.deactivateMDPAlert();
        }else{
            this.activateMDP();
        }
    }

    deactivateMDP(){
        this.pendingMDP(true);
        CompaniesService.deactivateMDPService(
            this.companyId
        ).then((res) => {
            this.handleSuccessAction(res);
            this.setMdpInfo(res.mdp);
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo desactivar el sistema MDP')
        }).finally(() => {
            this.openMdpPanel = null;
            this.pendingMDP(false);
        })
    }

    updateMDPConfig(){
        //actualizo configuracion de MDP ya activada
        this.updatingMDPConfig = true;
        CompaniesService.patchMDPService(
            this.companyId,
            this.username,
            this.userpassword
        ).then((res) => {
            this.handleSuccessAction(res);
            this.setMdpInfo(res.mdp);
            this.openMdpPanel = null;
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo actualizar la configuracion del sistema MDP')
        }).finally(() => {
            this.updatingMDPConfig = false;
        })
    }

    activateMDP(){
        //activo servicio MDP por primera vez
        this.pendingMDP(true);
        CompaniesService.activateMDPService(
            this.companyId,
            this.username,
            this.userpassword
        ).then((res) => {
            this.handleSuccessAction(res);
            this.setMdpInfo(res.mdp);
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo activar el sistema MDP')
        }).finally(() => {
            this.openMdpPanel = null;
            this.pendingMDP(false);
        })
    }

    activateOrDeactivateJourney(){
        if(this.hasActiveJourney){
            //si tiene activo jornales las desactivo
            this.deactivateJourneyAlert();
        }else{
            //de lo contrario se activa el sistema de jornales
            this.showModalActiveJourneys();
        }
    }

    deactivateJourney(){
        this.pendingJourneys(true);
        CompaniesService.deactivateJourney(
            this.companyId
        ).then((res) => {
            this.pendingJourneys(false);
            this.handleSuccessAction(res);
            this.setHasActiveJourney(false);
            this.setMdpInfo({
                username: '',
                password: '',
                is_active: false
            })
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo desactivar el sistema de jornales')
            this.pendingJourneys(false);
        })
    }
    showModalActiveJourneys(){
        this.visibilityModalActiveJourneys(true);
    }

     pendingJourneys(value){
        this.loadingJourneys = value;
    }

    @Emit()
    setHasActiveJourney(value: boolean) {}

    @Emit()
    setMdpInfo(value: CompanyDetail["mdp"]) {
        this.updateUsername(value.username);
        this.updateUserpassword(value.password);
        return value;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }


    visibilityModalActiveJourneys(value){
        this.visibleModalActivateJourneys = value;
    }



    deactivateJourneyAlert() {
        this.deactivateEvent = 'journeys';
        let companyName = this.companyData.name;
        this.deleteModalTitle = 'Desactivar sistema de jornales';
        this.deleteBody =
            `¿Está seguro que desea Desactivar el sistema de jornales para <b>${companyName}</b>?`;
            this.summaryDeactivate = [
                `<b>${companyName}</b> no tendra disponible el sistema de jornales.`,
                `Se dejaran de generar jornales para los vehiculos asociados a la empresa`,
            ]
        this.confirmationDelete = true;
    }

    deactivateMDPAlert(){
        this.deactivateEvent = 'mdp';
        let companyName = this.companyData.name;
        this.deleteModalTitle = 'Desactivar Sistema MDP';
        this.deleteBody =
            `¿Está seguro que desea Desactivar el sistema MDP para <b>${companyName}</b>?`;
            this.summaryDeactivate = [
                `<b>${companyName}</b> dejará de visualizar las órdenes de trabajo de Montes del Plata en la plataforma.`,
            ]
        this.confirmationDelete = true;
    
    }

    deactivateAction(value) {
        if (value) {
            this.confirmationDelete = false;
            if(this.deactivateEvent === 'journeys'){
                this.deactivateJourney();
            }else{
                this.deactivateMDP();
            }
        } else {
            this.confirmationDelete = false;
            this.deactivateEvent = '';
        }
    }


    

    @Emit()
    closeModal() {}

    mounted() {
        this.$nextTick(() => {
            this.updateUsername(this.companyData.mdp.username);
            this.updateUserpassword(this.companyData.mdp.password);
        });
    }

    
}
